import { gql } from 'apollo-boost'

export const FRAGMENT_CONTENT = gql`
  fragment contentFields on content {
    id
    title
    body
    files: content_assets {
      asset {
        id
        type
        description
        url
      }
    }
  }
`
export const FRAGMENT_LESSONPLAN = gql`
  fragment itemFields on item {
      lesson: item {
        lessonplan: item {
          template: item_template_lessonplan {
            id
            subject { id, name }
            lesson
          }
        }
      }
    }
    `

// ASSIGNMENT'S AUTHOR

export const QUERY_AUTHOR_ASSIGNMENTS = gql`
  ${FRAGMENT_LESSONPLAN}
  query Assignments($filter: item_bool_exp, $offset: Int, $limit: Int) {
    assignments: item(
      where: $filter,
      order_by: {created_at: desc},
      offset: $offset,
      limit: $limit
    ) {
      status
      ...itemFields
      id
      question: content {
        id
        title
      }
      createdAt: created_at
    }
    assignment_aggregate: item_aggregate(
      where: $filter
    ) {
      aggregate {
        count
      }
    }
  }
`

export const QUERY_ASSIGNMENT = gql`
  ${FRAGMENT_CONTENT}
  query Assignment($assignmentId: Int!) {
    assignment: item_by_pk(id: $assignmentId) {
      id
      question: content {
        ...contentFields
      }
      createdAt: created_at
    }
  }
`

export const QUERY_ASSIGNMENT_RESPONDERS_ANSWERS = gql`
  ${FRAGMENT_CONTENT}
  query AssignmentsRespondersAnswers($assignmentId: bigint) {
    answers: user_content(where: {context_id: {_eq: $assignmentId}, type:{_eq: ASSIGNMENT}}) {
      id
      user {
        id
        firstname
        lastname
        avatar_url
      }
      status
      content {
        ...contentFields
      }
      createdAt: created_at
    }
  }
`

export const QUERY_ASSIGNMENT_RESPONDERS_ANSWER = gql`
  ${FRAGMENT_CONTENT}
  query AssignmentsRespondersAnswers($answerId: Int!) {
    answer: user_content_by_pk(id: $answerId) {
      id
      user {
        id
        firstname
        lastname
      }
      content {
        ...contentFields
      }
      createdAt: created_at
    }
    grade: score(where: {context_id:{_eq: $answerId}, type: {_eq: WORKSHEET}}){
      id
      feedback
      score
    }
  }
`

// RESPONDER

export const QUERY_RESPONDER_ASSIGNMENTS = gql`
  ${FRAGMENT_LESSONPLAN}
  query ResponderAssignments($filter: user_content_bool_exp!, $offset: Int!, $limit: Int!) {
    assignments: user_content(
      where: $filter,
      order_by: {created_at: desc},
      offset: $offset,
      limit: $limit
    ) {
      id
      status
      type
      context_id
      question: item {
        ...itemFields
        content {
        id
        title
        }
      }
      createdAt: created_at
    }
    assignment_aggregate: user_content_aggregate(
      where: $filter
    ) {
      aggregate {
        count
      }
    }
  }
`

export const QUERY_RESPONDER_ASSIGNMENT = gql`
  ${FRAGMENT_CONTENT}
  query ResponderAssignment($assignmentId: Int!) {
    assignment: user_content_by_pk(id: $assignmentId) {
      id
      type
      status
      question: item {
        content {
          ...contentFields
        }
      }
      content {
        ...contentFields
      }
      createdAt: created_at
    }
    grade: score(where: {context_id: {_eq: $assignmentId}, type: {_eq: WORKSHEET}}) {
      id
      score
      feedback
    }
  }
`

export const MUTATION_SUBMIT_ANSWER = gql`
  mutation SubmitAnswer($assignmentId: Int!, $answer: String!) {
    update_content(where: {user_contents: {id: {_eq: $assignmentId}}}, _set: {body: $answer}) {
      affected_rows
    }
    update_user_content_by_pk(pk_columns: {id: $assignmentId}, _set: {status: SUBMITTED}) {
      id
    }
  }
`

export const MUTATION_SUBMIT_ANSWER_WITH_ATTACHMENTS = gql`
  mutation SubmitAnswer($assignmentId: Int!, $answer: String!, $attachments: [asset_insert_input!]!) {
    update_content(where: {user_contents: {id: {_eq: $assignmentId}}}, _set: {body: $answer}) {
      affected_rows
    }
    update_user_content_by_pk(pk_columns: {id: $assignmentId}, _set: {status: SUBMITTED}) {
      id
    }
    insert_asset(objects: $attachments) {
      affected_rows
      returning {
        id
        content_assets {
          content_id
        }
      }
    }
  }
`

export const MUTATION_SET_ASSIGNMENT_SCORE = gql`
  mutation SetAssignmentScore($responderId: Int!, $feedback: String, $score: Int, $answerId: Int!) {
    score: insert_score_one(object: {
      scoree_id: $responderId,
      scoree_type: USER,
      score: $score,
      feedback: $feedback,
      type: WORKSHEET,
      context_type: USER_CONTENT,
      context_id: $answerId
    }) {
      id
    }

    gradedAnswer: update_user_content_by_pk(pk_columns: {id: $answerId}, _set: {status: GRADED}) {
      id
      status
    }
  }
`

export const SUBSCRIPTION_UNANSWERED_ASSIGNMENT_COUNT = gql`
  subscription UnansweredAssignmentCount($userId: Int!) {
    assignment_aggregate: user_content_aggregate(
      where:
      {
        type: { _eq: ASSIGNMENT },
        _and: [
          {
            user_id: { _eq: $userId }
          },
          {
            status: { _eq: DRAFT }
          },
          {
            item: {}
          }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`

export const SUBSCRIPTION_ANSWERED_ASSIGNMENT_COUNT = gql`
  subscription UnansweredAssignmentCount($userId: Int!) {
    assignment_aggregate: user_content_aggregate(
      where:
      {
        type:{ _eq: ASSIGNMENT },
        _and: [
          {
            user_id: { _eq:$userId }
          },
          {
            status: { _in: [GRADED, SUBMITTED] }
          },
          {
            item: {}
          }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`
export const SUBSCRIPTION_TOTAL_ASSIGNMENT_COUNT = gql`
  subscription UnansweredAssignmentCount($userId: Int!) {
    assignment_aggregate: user_content_aggregate(
      where:
      {
        type:{ _eq: ASSIGNMENT },
        _and: [
          {
            user_id: { _eq:$userId }
          },
          {
            status: { _in: [DRAFT, GRADED, SUBMITTED] }
          },
          {
            item: {}
          }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`
